import { ReactNode } from 'react';

export default function Container({ fullHeight, children }: { fullHeight?: boolean; children: ReactNode }) {
  return <div className={`container mx-auto px-6 pb-6 pt-6 lg:pt-0 mb-auto ${fullHeight ? 'h-full' : ''}`}>{children}</div>;
}
